import Helper from "./Helper";

class RelevanceMatrix {
  constructor(config = {}) {
    const { idName, className } = config;

    this.idName = idName;
    this.className = className;

    const toggles = Array.prototype.slice.call(
      document.querySelectorAll(`g[id*="${this.idName}"]`)
    );
    toggles.forEach(toggle => {
      toggle.addEventListener("click", () => {
        const toggleNum = toggle.id.replace(this.idName, "");
        console.log(toggleNum);
        const popup = document.querySelector(`.${className}${toggleNum}`);

        Helper.addClass(popup, "is-visible");
        // Helper.addClass(document.querySelector("body"), "notes-open");
        setTimeout(() => {
          Helper.addClass(popup, "fade-in");
        }, 300);
      });
    });
  }
}

export default RelevanceMatrix;
